import {DomainEvent} from './DomainEvent';
import type {Iso8601DateString} from '@fupa/fupa-ts-core';
import type {EntityExportRequest} from './EntityExportRequest';

export interface TopElevensExportRequest extends EntityExportRequest {
  /** the creation date of the models to start the export for */
  readonly from?: Iso8601DateString | null;
  /** the creation date of the models to end the export for */
  readonly to?: Iso8601DateString | null;
}

/**
 * This event can be fired to indicate that a service requires top eleven models within a specific date interval.
 * Another service that is eligible to provide this info will put batches of the requested models into
 * the specified S3 {@see TopElevensExportRequest.targetBucket} using
 * the {@see TopElevensExportRequest.transactionId} as prefix (sub-folder).
 */
export class TopElevensExportRequested extends DomainEvent<TopElevensExportRequest> {}
